import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { emaki_brand } from "../../utils/types/emaki_brand";
import { filterTag_template } from "./filterTag_template";
import { vignettePreview_template } from "./vignettePreview_template";

declare var ko: any;

export class vignettesView_template extends vnTemplate {
    protected tagFilter: filterTag_template;
    protected vignettePreview: vignettePreview_template;

    protected getTemplateHtml(): string {

        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title icon i-summary"  data-bind="text: name">Vignette</h3>
                    <div class="w-btn">
                        <!-- ko if: isBrandOwner() -->
                            <button data-bind="event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Vignette</button>
                        <!-- /ko -->
                    </div>
                </div>
                <div class="w-form-body">

                    <div class="form-body">

                        <strong class="form-sub-title no-margin">Code</strong>

                        <div class="form-group-row">
                            <div class="form-group">
                                <label for="" class="form-label">HTML</label>
                                <pre id="htmlEditor" data-bind="text: html"></pre>
                            </div>

                            <div class="form-group">
                                <label for="" class="form-label">CSS</label>
                                <pre id="cssEditor" data-bind="text: css"></pre>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="w-form-body">

                    <div class="form-body">

                        <strong class="form-sub-title no-margin">Preview</strong>
                        <div class="form-group" style="width: 40%">
                            ${ this.tagFilter.getHtmlBuild() }
                        </div>

                        <div class="form-group">
                            ${ this.vignettePreview.getHtmlBuild() }
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    public setBindings(html, css) {
        this.getTemplateViewModel().html(html);
        this.getTemplateViewModel().css(css);
    }

    protected initPartial(): void {

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.vignettePreview = new vignettePreview_template("vignettePreview", this.getTemplateViewModel(), this.caller);
        this.vignettePreview.setShowKeys(true);
    }

    protected getTemplateName(): string {

        return "vignettesView_template";
    }

    protected buildViewModel(): any {

        const self = this;

        return {
            brand: ko.observable(""),
            id: ko.observable(""),
            name: ko.observable(""),
            html: ko.observable(""),
            css: ko.observable(""),
            isBrandOwner: ko.pureComputed(() => self.getIsBrandOwner()),
            brandOwner: ko.observable(null),
            onClickCancel: function (data, event) {
                self.onClickCancel(data.id());
            },
            onClickEdit: function (data, event) {
                self.onClickEdit(data.id());
            }
        }
    }

    public getIsBrandOwner = (): boolean => {
        const vm = this.getTemplateViewModel();

        return (vm.brandOwner() && vm.brand())? vm.brandOwner().id == vm.brand() : false;
    }

    public onClickCancel(id) {
        this.caller.cancel(id);
    }

    public onClickEdit(id) {
        this.caller.edit(id);
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setName(name): void {
        this.getTemplateViewModel().name(name);
    }

    public setHtml(value): void {
        this.vignettePreview.setHtml(value);
        this.getTemplateViewModel().html(value);
    }

    public setCss(value): void {
        this.vignettePreview.setCss(value);
        this.getTemplateViewModel().css(value);
    }

    public setBrand(brand: number): void {
        this.getTemplateViewModel().brand(brand);
    }

    public setBrandOwner(brand: emaki_brand): void {
        this.getTemplateViewModel().brandOwner(brand);
    }

    protected setTagFilter(tags) {
        this.getTemplateViewModel().tagFilter.tags(tags);
    }

    public updateTagForPreview() {
        this.caller.getPreviewTag(this.tagFilter.getTemplateViewModel().idTag(), 'previewContainer');
    }

    public setIndexedValues(tag=null, specsValues=[], specDefaults=[]) {
        this.vignettePreview.setShowKeys(!tag || Object.keys(tag).length === 0);
        this.vignettePreview.setIndexedValues(tag, specsValues, specDefaults);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettesView_template.ts